import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { AdminBooking } from '../models/admin.models';
import { ApiResponse, PaginatedResponse } from '../models/api-response.model';

@Injectable({
  providedIn: 'root'
})
export class AdminBookingsService {
  private baseUrl = `${environment.apiBaseUrl}/admin/bookings`;

  constructor(private http: HttpClient) {}

  getBookings(): Observable<PaginatedResponse<AdminBooking>> {
    return this.http.get<any>(this.baseUrl).pipe(
      map(res => res.data ?? res)
    );
  }

  getBooking(id: number): Observable<AdminBooking> {
    return this.http.get<ApiResponse<AdminBooking>>(`${this.baseUrl}/${id}`).pipe(
      map(res => res.data)
    );
  }

  assignMechanic(bookingId: number, mechanicUserId: number): Observable<AdminBooking> {
    return this.http.post<ApiResponse<AdminBooking>>(
      `${this.baseUrl}/${bookingId}/assign`,
      { mechanic_user_id: mechanicUserId }
    ).pipe(map(res => res.data));
  }
}
